import React from 'react';

import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  Button,
  Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateTimeFormatter, localeFormatter, subjectFormatterForNotification,
} from '../../../utils/formatters';
import { NOTIFICATION_TYPE, ROLLBACK_VERSION_STATUS } from '../../../configs';
import { intlShape } from '../../../components/base/IntlProviderWrapper';

export default function NotificationPopUp(props) {
  const {
    onClose = () => {}, current = {}, setShowRollbackPlan = () => {}, showResultRollback = () => {},
  } = props;
  const {
    formatMessage,
  } = intlShape;

  const {
    created_at, data = {}, type_raw: type = '',
  } = current;

  const rollback_status = data?.subjects[0]?.subject_status;
  const automation_rule_id = data?.context?.automation_rule_id;

  const isRollback = type === NOTIFICATION_TYPE.ROLLBACK && rollback_status;

  const isCarrier = [NOTIFICATION_TYPE.CARRIER_INSURANCE_CONTRACT_EXPIRED].includes(type);
  const isSzlt = [NOTIFICATION_TYPE.ORDER_SERVICE_EXPIRED].includes(type);
  const isVehicles = [NOTIFICATION_TYPE.VEHICLE_INSURANCE_CONTRACT_EXPIRED].includes(type);

  const isAutomatization = automation_rule_id && (isCarrier || isSzlt || isVehicles);

  const subjects = data?.subjects || [];

  const renderMessage = message => {
    if (!message) return null;

    if (Array.isArray(message)) {
      return message.map((item, idx) => <div key={idx}>{item}</div>);
    }

    return message;
  };

  const handleAutomatizationUrl = () => {
    if (!automation_rule_id) {
      return '';
    }

    if (isCarrier) {
      return `/region-registry-carrier?automation_rule_id=${automation_rule_id}`;
    }
    if (isVehicles) {
      return `/region-registry/passenger-taxi?automation_rule_id=${automation_rule_id}`;
    }
    if (isSzlt) {
      return `/region-registry/szlt?automation_rule_id=${automation_rule_id}`;
    }

    return '';
  };

  return (
    <Dialog
      className="pnp-popup-view"
      onClose={onClose}
      open
    >
      <DialogTitle header="Просмотр бланка уведомления" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="pnp-view-content">
        <div className="pnp-view-table">
          <Row className="row-cols-2">
            <Col className="pnp-view-label" columns={4}>Тип уведомления</Col>
            <Col className="pnp-view-value" columns={4}>{current.type_raw === NOTIFICATION_TYPE.IMPORT ? `[${localeFormatter('import.notification', current?.entity_type)}]` : ''} {current.type_label}</Col>
          </Row>
          {/* <Row className="row-cols-2"> */}
          {/*  <Col className="pnp-view-label" columns={4}>Объект</Col> */}
          {/*  <Col className="pnp-view-value column" columns={8}> */}
          {/*    { */}
          {/*      (data?.subjects || []).map(subject => ( */}
          {/*        subjectFormatterForNotification(subject) */}
          {/*      )) */}
          {/*    } */}
          {/*  </Col> */}
          {/* </Row> */}
          <Row className="row-cols-2">
            <Col className="pnp-view-label" columns={4}>Дата создания</Col>
            <Col className="pnp-view-value" columns={8}>{dateTimeFormatter(created_at)}</Col>
          </Row>
          {/* <Row clas{current.message || ''}sName="row-cols-2"> */}
          {/*  <Col className="pnp-view-label" columns={4}>Текст</Col> */}
          {/*  <Col className="pnp-view-message" columns={8}>{current.message || ''}</Col> */}
          {/* </Row> */}
        </div>
        <div className="mt-4 mb-3">{renderMessage(current.message)}</div>
        <div className="mt-4 mb-3">
          <div>Затронуты объекты ({subjects.length} шт.):</div>
          {subjects.map((subject, index) => (
            <span key={index}>
              {subjectFormatterForNotification(subject)}
              {subjects.length === index + 1 ? null : <span>, </span>}
            </span>
          ))}
        </div>
      </DialogContent>
      {isRollback
        ? (
          <DialogFooter>
            {rollback_status === ROLLBACK_VERSION_STATUS.NEW
              ? (
                <Button
                  className="hff-show-data"
                  variant="secondary"
                  onClick={() => setShowRollbackPlan(true)}
                >
                  Перейти в план отката версии
                </Button>
              )
              : (
                <Button
                  className="hff-show-data"
                  variant="secondary"
                  onClick={() => showResultRollback()}
                >Перейти в просмотр результата отката
                </Button>
              )}
          </DialogFooter>
        ) : null }
      {isAutomatization ? (
        <DialogFooter>
          <Button
            className="hff-clear-data"
            onClick={() => window.open(handleAutomatizationUrl(), '_blank')}
          >
            { `${formatMessage({ id: `menu.region.registry.${isCarrier ? 'carrier' : isSzlt ? 'szlt' : 'passenger.taxi'}` })} с фильтром`}
          </Button>
        </DialogFooter>
      ) : null }
    </Dialog>

  );
}
